<template>
  <div class="gift-form-page">
    <Header />
    <div class="container">
      <div class="gift-section">
        <GoldGiftForm :currentprice="gold ? gold.current_price ? gold.current_price : 0 : 0" @historyCallback="getGiftingHistory" />
      </div>
      <GiftHistory :giftHistory="giftHistory" />
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import Header from "../components/Header";
import GoldGiftForm from "../components/GoldGiftForm";
import GiftHistory from "../components/GiftHistory";
import { toaster } from "../utils/helper";
export default {
  name: "GiftForm",
  components: {
    Header, 
    GoldGiftForm,
    GiftHistory,
    },
    data() {
      return {
        giftHistory: []
      }
    },
  computed: {
    ...mapGetters(["gold"])
  },
  methods: {
    getGiftingHistory() {
      this.$store
      .dispatch({ type: "giftingHistory" })
      .then(data => {
         this.giftHistory = data.data.reverse();
     })
      .catch(err => {
        toaster(this, this.$t("somethingwentwrong"), "top-left", 2000);
      });
    }
  },
  mounted() {
    this.getGiftingHistory()
  }
};
</script>